import { render, staticRenderFns } from "./NatoGroupClass.vue?vue&type=template&id=b143f2c8"
import script from "./NatoGroupClass.vue?vue&type=script&lang=js"
export * from "./NatoGroupClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports